<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>search</md-icon>
              지부/분회 검색
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="mb10">
              <md-button v-focus slot="footer" class="md-info md-sm full-size-button" @click="() => {this.isShowBranchModal = true}">
                <md-icon>open_in_new</md-icon>
                지부/분회 검색
              </md-button>
            </div>

            <table class="flex-table">
              <tr>
                <th star>지부/분회명</th>
                <td>
                  <span>{{ info.branchNm }}</span>
                </td>
              </tr>
              <tr>
                <th star>지부/분회 종류</th>
                <td>
                  <span>{{ info.branchGbNm }}</span>
                </td>
              </tr>
            </table>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>
              회비 입력
            </h4>
          </md-card-header>
          <md-card-content>
            <div :class="{ mb10 : this.isShowWrite }">
              <md-button :disabled="info.branchId === undefined" slot="footer" class="md-info md-sm full-size-button" @click="() => {this.isShowWrite = true; this.isEditMode = false;}">
                <md-icon>check</md-icon>
                신규 회비 입력
              </md-button>
            </div>
            <table class="flex-table" v-if="isShowWrite">
              <tr>
                <th star>입금처리일</th>
                <td>
                  <div class="inline-flex">
                    <input type="text" v-model="feeInfo.feeDate" v-mask="'####-##-##'">
                  </div>
                </td>
              </tr>
              <tr>
                <th star>회비구분</th>
                <td>
                  <select v-model="feeInfo.feeCd">
                    <option value="">선택</option>
                    <option v-for="item in feeCdList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                  </select>
                </td>
              </tr>
              <tr>
                <th star>회비년도</th>
                <td>
                  <input type="text" v-model="feeInfo.feeYear" v-mask="'####'">
                </td>
              </tr>
              <tr>
                <th star>납부교우</th>
                <td>
                  <div class="inline-flex">
                    <input type="text" v-model="feeInfo.memberNo" disabled>
                    <button @click="() => { this.isShowMemberModal = true }">
                      <md-icon>search</md-icon>
                    </button>
                    <span>
                      {{ feeInfo.memberHnm }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <th star>납부인원</th>
                <td>
                  <input type="text" v-model="feeInfo.feeCnt" v-mask="'######'">
                </td>
              </tr>
              <tr>
                <th star>납입금액</th>
                <td>
                  <input type="text" v-model="feeInfo.feeAmt" v-mask="'############'">
                </td>
              </tr>
              <tr>
                <th star>납부방법</th>
                <td>
                  <div class="inline-flex">
                    <select v-model="feeInfo.feeWay">
                      <option value="">선택</option>
                      <option v-for="item in feeWayList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                    </select>
                    <span>은행</span>
                    <select v-model="feeInfo.bankCd" :disabled="feeInfo.feeWay !== '03'" >
                      <option value="">선택</option>
                      <option v-for="item in bankCdList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <th>비고</th>
                <td>
                  <textarea v-model="feeInfo.feeEtc"></textarea>
                </td>
              </tr>
            </table>
          </md-card-content>

          <md-card-actions v-if="isShowWrite">
            <md-button class="md-info md-sm full-size-button" @click="saveFeeInfo">
              <md-icon>check</md-icon>
              저장
            </md-button>
            <md-button class="md-default md-sm" @click="initFeeInfo">
              <md-icon>clear</md-icon>
              초기화
            </md-button>
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">

        <!-- 납부내역 -->
        <group-fee-list-comp ref="groupFeeList" @returnResult="onClickBranchFee"></group-fee-list-comp>

        <!-- 납부내역 -->
        <group-member-list-comp ref="groupMemberList" @returnResult="onClickBranchFee" @hook:mounted="searchBranchFeeList"></group-member-list-comp>



      </div>
    </div>


    <!--교우검색 팝업 -->
    <branch-member-search-pop-comp :is-show.sync="isShowMemberModal" :branch-id="info.branchId" :branch-nm="info.branchNm" @returnResult="onClickModalMember"></branch-member-search-pop-comp>

    <!--지부/분회 선택 팝업-->
    <branch-search-pop-comp :is-show.sync="isShowBranchModal" @returnResult="onClickModalBranch"></branch-search-pop-comp>

  </div>
</template>

<script>
  import kuaaApi from "@/kuaa/kuaa-api";
  import kuaaFnc from "@/kuaa/kuaa-comm-func";
  import URL_CONST from "@/kuaa/kuaa-url-const";
  import formatter from "@/kuaa/kuaa-formatter";
  import Swal from "sweetalert2";
  import moment from "moment";

  import { BranchSearchPopComp } from "@/pages";
  import GroupFeeListComp from "@/pages/MembershipFee/Components/GroupFeeListComp";
  import GroupMemberListComp from "@/pages/MembershipFee/Components/GroupMemberListComp";

  import { BranchMemberSearchPopComp } from "@/pages"

  export default {

    components: {
      BranchMemberSearchPopComp,
      BranchSearchPopComp,
      GroupFeeListComp,
      GroupMemberListComp
    },

    props: {
      branchId: {
        type: String,
        default : null
      },
      branchNm: {
        type: String,
        default : null
      },
      branchGb: {
        type: String,
        default : null
      }
    },

    // watch: {
    //   info: function(){
    //     return this.branchId;
    //   },
    //   selectedBranchNm: function(){
    //     return this.branchNm;
    //   }
    // },

    data(){
      return{
        //selectedBranchId: null,
        //selectedBranchNm: null,
        formatter,
        isShowBranchModal: false,
        isShowMemberModal : false,

        feeCdList: [],
        feeWayList: [],
        bankCdList: [],

        // 신규회비 입력
        isShowWrite: false,
        isEditMode: false,
        feeInfo: {
          feeDate: moment().format("YYYYMMDD"),
          feeYear: kuaaFnc.getCurrentYear(),
          feeCd: "",
          memberNo: "",
          memberHnm: "",
          feeCnt: "",
          feeAmt: "",
          feeWay: "",
          bankCd: "",
          feeEtc: ""
        },

        //info: {},// 왼쪽 영역 선택한 branch
        info: {
          branchNm : this.branchNm,
          branchGb : this.branchGb,
          branchId : this.branchId
        },

        // 납부 내역 목록
        branchFeeList: [],
        selectedBranchFeeRows: [],

        // 단체회원 목록
        branchMemberList: [],
        selectedBranchMemberRows: [],
      };
    },

    created() {
      this.queryFeeCdTypes();
      this.queryFeeWayTypes();
      this.queryBankCdTypes();
      if(this.branchId){
        this.info = {
          branchNm : this.branchNm,
          branchGb : this.branchGb,
          branchId : this.branchId
        };
      }
    },

    methods:{
      /**
       * 납부방법코드 - 공통코드 조회 세팅
       */
      queryFeeCdTypes() {
        kuaaFnc.fncFeeCdTypes(null,res => {
          this.feeCdList = res.data.data.contents;
        });
      },

      /**
       * 납부방법코드 - 공통코드 조회 세팅
       */
      queryFeeWayTypes() {
        kuaaFnc.fncFeeWayTypes(null,res => {
          this.feeWayList = res.data.data.contents;
        });
      },

      /**
       * 납부방법코드 - 공통코드 조회 세팅
       */
      queryBankCdTypes() {
        kuaaFnc.fncBankCodes(null,res => {
          this.bankCdList = res.data.data.contents;
        });
      },

      /**
       * 지부/분회 검색 모달 검색 결과에서 항목 선택
       * @param item
       */
      onClickModalBranch(item) {
        this.info = item;
        this.isShowBranchModal = false;
        this.searchBranchFeeList();
      },

      /**
       * 선택한 지부/분회의 납부 내역 조회
       */
      searchBranchFeeList() {
        if(this.info.branchId && this.$refs.groupFeeList && this.$refs.groupMemberList){
          this.$refs.groupFeeList.sendQuery(this.info.branchId);
//          this.$refs.groupMemberList.sendQuery({branchId : this.info.branchId, feeDate: this.info.feeDate, feeTime: this.info.feeTime});
        }
      },

      selectBranchMemberRow(rowList) {
        this.selectedBranchMemberRows = rowList;
      },

      /**
       * 회비 입력
       */
      saveFeeInfo() {
        let modalOptions = kuaaFnc.getSwalModaloptions();

        if(!this.feeInfo.feeDate || this.feeInfo.feeDate.trim() == ''){
          modalOptions['html'] = '입금처리일을 입력하세요.';
          Swal.fire(modalOptions);
          return;
        }else{
          if(!moment(this.feeInfo.feeDate, "YYYY-MM-DD").isValid()){
            modalOptions['html'] = '유효하지 않은 입금처리일 입니다.';
            Swal.fire(modalOptions);
            return;
          };

        }

        if(!this.feeInfo.feeCd || this.feeInfo.feeCd == ''){
          modalOptions['html'] = '회비구분을 선택하세요.';
          Swal.fire(modalOptions);
          return;
        }

        if(!this.feeInfo.feeYear || this.feeInfo.feeYear.trim() == ''){
          modalOptions['html'] = '회비년도를 입력하세요.';
          Swal.fire(modalOptions);
          return;
        }else{
          if(!moment(this.feeInfo.feeYear, "YYYY").isValid()) {
            modalOptions['html'] = '유효하지 않은 회비년도 입니다.';
            Swal.fire(modalOptions);
            return;
          }
        }

        if(!this.feeInfo.memberNo){
          modalOptions['html'] = '납부교우를 입력하세요.';
          Swal.fire(modalOptions);
          return;
        }

        if(!this.feeInfo.feeCnt || this.feeInfo.feeCnt < 1){
          modalOptions['html'] = '납부인원을 입력하세요.';
          Swal.fire(modalOptions);
          return;
        }

        if(!this.feeInfo.feeAmt || this.feeInfo.feeAmt < 1000){
          modalOptions['html'] = '납입금액을 입력하세요.<br>(1,000 이상)';
          Swal.fire(modalOptions);
          return;
        }

        if(!this.feeInfo.feeWay || this.feeInfo.feeWay == ''){
          modalOptions['html'] = '납부방법을 선택하세요.';
          Swal.fire(modalOptions);
          return;
        }

        // if(!this.selectedHisData.erectDate || this.selectedHisData.erectDate == ''){
        //   modalOptions['html'] = '취임일을 입력 하세요';
        //   Swal.fire(modalOptions);
        //   return;
        // }
        //
        // if(!this.selectedHisData.levelCd|| this.selectedHisData.levelCd == ''){
        //   modalOptions['html'] = '직위를 선택 하세요';
        //   Swal.fire(modalOptions);
        //   return;
        // }

        modalOptions = {
          title: "단체 회비 납부내역 저장",
          type: "warning",
          showCancelButton: false,
          confirmButtonClass: "md-button md-info",
          cancelButtonClass: "md-button md-default",
          confirmButtonText: "확인",
          buttonsStyling: false
        };

        let options = JSON.parse(JSON.stringify(this.feeInfo));
        options.branchId = this.info.branchId;
        options.feeDate = moment(options.feeDate).format("YYYYMMDD");
        options.feeTime = moment().format("hhmmss");
        options.branchGb = this.info.branchGb;
        delete options.memberHnm;
        
        kuaaApi.sendServer(
          URL_CONST.SAVE_BRANCH_FEE,
          options,
          "post",
          response => {
            if (response.data.success){
              modalOptions.html = `단체 회비가 저장 되었습니다.`;
              Swal.fire(modalOptions);
              this.searchBranchFeeList();
            } else {
              modalOptions.html = `단체 회비 저장 실패 하였습니다.`;
              Swal.fire(modalOptions);
            }
          }
        );
      },

      /**
       * 회비입력 항목 초기화
       */
      initFeeInfo() {
        this.isEditMode = false;
        this.feeInfo = {
          feeDate: moment().format("YYYYMMDD"),
          feeYear: kuaaFnc.getCurrentYear(),
          feeCd: "",
          memberNo: "",
          memberHnm: "",
          feeCnt: "",
          feeAmt: "",
          feeWay: "",
          bankCd: "",
          feeEtc: ""
        }
      },

      /**
       * 모달 교우선택 목록에서 교우를 선택 (교우 변경 기능)
       */
      onClickModalMember(item) {
        // this.isCreateMode = false;
        this.isShowMemberModal = false;
        this.feeInfo.memberNo = item.memberNo;
        this.feeInfo.memberHnm = item.memberHnm;
      },

      onClickBranchFee(item) {
        this.isShowWrite = true;
        this.isEditMode = true;
        if(item){
          this.$refs.groupMemberList.sendQuery({branchId : this.info.branchId, feeDate: item.feeDate, feeTime: item.feeTime});
          item.feeDate = moment(item.feeDate).format("YYYY-MM-DD");
          this.feeInfo = item;
        }else{
          this.initFeeInfo();
          this.$refs.groupMemberList.sendQuery({branchId : this.info.branchId, feeDate: null, feeTime: null});
        }
      }
    }
  };
</script>

<style>

</style>